var DELIVERY_EVENT = {
  easter: {
    prefix: 'Get',
    name: 'Easter'
  },
  fathers_day: {
    prefix: 'Get',
    name: "Father's day"
  },
  halloween: {
    prefix: 'Get',
    name: 'Halloween'
  },
  mothers_day: {
    prefix: 'Get',
    name: "Mother's day"
  },
  valentines_day: {
    prefix: 'Get',
    name: "Valentine's day"
  },
  christmas: {
    prefix: 'Arrives',
    name: 'Christmas'
  }
};
export var getDeliveryByEventName = function getDeliveryByEventName(deliveryEvent) {
  return DELIVERY_EVENT[deliveryEvent];
};
export var getDeliveryByEventLabel = function getDeliveryByEventLabel(deliveryEvent) {
  var eventDetails = getDeliveryByEventName(deliveryEvent);
  return eventDetails ? "".concat(eventDetails.prefix, " by ").concat(eventDetails.name) : '';
};